export const routes = {
  // Auth (tracking realm) — keys the auth pages/guards already reference.
  login: '/login',
  loginVerifyOtp: '/login/verify-otp',
  signup: '/signup',
  forgotPassword: '/forgot-password',
  forgotVerify: '/forgot-password/verify',
  forgotReset: '/forgot-password/reset',

  // Home redirects to /devices.
  home: '/',

  devices: '/devices',
  device: (id = ':id') => `/devices/${id}`,

  map: '/map',

  subscriptions: '/subscriptions',

  support: '/support',
  ticket: (id = ':id') => `/support/${id}`,

  // Notification settings + center.
  notifications: '/notifications',

  profile: '/profile',

  notFound: '/404',
  serverError: '/500',
} as const;
